/**
 * MobileManagersPermissionTab
 *
 * This used to be a second, hand-written copy of the permission grid for phones.
 * It had drifted away from the desktop tab in ways that changed what gets saved,
 * not just how it looks:
 *
 *  - it built every scope with only `view` / `edit` / `remove`, so the two
 *    "all teams" tiers had nowhere to live. Any `view_all` / `edit_all` grant
 *    read back from the API was funnelled into `view` (the team branch of its
 *    rebuild pushed every non-`edit` type into `view`), which silently demoted
 *    a company-wide grant to the manager's own teams on the next save;
 *  - it offered `remove` on `ventr` only, while the desktop offers it on
 *    `evaluations`, `ventr` and `warnings`, and offered `view_all` / `edit_all`
 *    on global scopes, which have no such tiers;
 *  - it had none of the desktop's floor rules (`news` / `vsecurite` /
 *    `vreference` cannot be removed, `vlearn` has three tiers, not four);
 *  - it saved *every* profile at once on Update, where the desktop saves the
 *    one profile on screen, and its dirty flag was set by any tap rather than
 *    by an actual diff against what was loaded.
 *
 * Rather than re-derive all of that a second time — the duplication is what
 * caused the drift — the phone now renders the same container as the desktop.
 * Its layout at phone width is handled by the `max-width: 767.98px` block in
 * Permissions.module.css: the Bootstrap columns already collapse to one column,
 * the tier buttons wrap two-up at 44px tall, and the Update button becomes a
 * sticky bar with a safe-area inset.
 *
 * Keep this file as the mobile entry point so the `mobile/` convention still
 * points somewhere, and so any future phone-only presentation has a home that
 * cannot fork the permission model again.
 */
import React from "react";
import ManagersPermissionTab from "../ManagersPermissionTab";

export default function MobileManagersPermissionTab({ defaultProfile }) {
    return <ManagersPermissionTab defaultProfile={defaultProfile} />;
}
